import { render, staticRenderFns } from "./textScroll.vue?vue&type=template&id=bc149144&scoped=true&"
import script from "./textScroll.vue?vue&type=script&lang=js&"
export * from "./textScroll.vue?vue&type=script&lang=js&"
import style0 from "./textScroll.vue?vue&type=style&index=0&id=bc149144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc149144",
  null
  
)

export default component.exports